export function idGenerator() {
  return 'id-' + Math.random().toString(36).substr(2, 9);
}

export function parseSideValue(raw) {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'number') return raw;
  const s = String(raw).trim();
  const m = s.match(/^(-?[\d.]+)([a-z%]*)$/i);
  if (!m) return null;
  return Number(m[1]);
}

export function parseShorthandString(str) {
  if (!str || typeof str !== 'string') return ['', '', '', ''];
  const tokens = str.trim().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return ['', '', '', ''];

  const nums = tokens.map(t => parseSideValue(t));
  if (nums.length === 1) return [nums[0], nums[0], nums[0], nums[0]];
  if (nums.length === 2) return [nums[0], nums[1], nums[0], nums[1]];
  if (nums.length === 3) return [nums[0], nums[1], nums[2], nums[1]];
  return [nums[0], nums[1], nums[2], nums[3]];
}

export function normalizeSpacingVal(val) {
  // val может быть строкой (css shorthand), массив, объект или число
  if (val == null) return ['', '', '', ''];
  if (typeof val === 'string') return parseShorthandString(val).map(v => v == null ? '' : v);
  if (Array.isArray(val)) {
    const arr = val.slice(0, 4).map(v => (v == null ? '' : (typeof v === 'string' ? parseSideValue(v) : v)));
    while (arr.length < 4) arr.push(arr[arr.length - 1] ?? '');
    return arr;
  }
  if (typeof val === 'object') {
    const top = parseSideValue(val.top ?? val.t ?? val[0]);
    const right = parseSideValue(val.right ?? val.r ?? val[1]);
    const bottom = parseSideValue(val.bottom ?? val.b ?? val[2]);
    const left = parseSideValue(val.left ?? val.l ?? val[3]);
    return [
      top == null ? '' : top,
      right == null ? '' : right,
      bottom == null ? '' : bottom,
      left == null ? '' : left
    ];
  }
  if (typeof val === 'number') return [val, val, val, val];
  return ['', '', '', ''];
}

export function buildSpacingString(arr) {
  if (!arr || !Array.isArray(arr)) return undefined;
  const allEmpty = arr.every(v => v === '' || v == null || (typeof v === 'number' && Number.isNaN(v)));
  if (allEmpty) return undefined;
  const normalized = arr.map(v => {
    if (v === '' || v == null) return 0;
    return Number(v);
  });
  return normalized.map(n => `${n}rem`).join(' ');
}
